<template>
  <div>
    <footer class="e-foot">
      <div>
        <div class="brand">
          <img v-if="showLogo" class="e-logo" :src="logo" :alt="brandName" @error="logoError = true" />
          <template v-else>
            <span class="e-mark">{{ markLetter }}</span>
            <span class="nm">{{ brandName }}</span>
          </template>
        </div>
        <p>{{ address }}</p>
        <div class="chips">
          <i v-for="name in channelList" :key="name">{{ name }}</i>
        </div>
      </div>

      <div>
        <h4>{{ $t('legal') }}</h4>
        <a href="javascript:;" @click="jump('conduct')">Rules of Conduct</a>
        <a href="javascript:;" @click="jump('tos')">Terms of service</a>
        <a href="javascript:;" @click="jump('privacy')">Privacy policy</a>
      </div>

      <div>
        <h4>{{ $t('contact_us') }}</h4>
        <p style="margin-bottom:7px">{{ email }}</p>
        <p style="margin-bottom:7px">{{ phone }}</p>
        <p>{{ address }}</p>
      </div>
    </footer>

    <div class="e-copy">
      <span class="e-lbl">{{ copyRight }}</span>
      <span class="e-lbl">{{ region }}</span>
    </div>
  </div>
</template>

<script>
import env from '../assets/js/env'

const CHANNELS = {
  IDR: ['DANA', 'OVO', 'SHOPEEPAY', 'LINKAJA', 'QRIS', 'ASTRAPAY', 'BCA', 'BNI', 'BRI', 'CIMB', 'MANDIRI', 'PERMATA', 'ALFAMART', 'CREDIT'],
  THB: ['BAY', 'BBL', 'CREDIT', 'KBANK', 'KTB', 'LINEPAY', 'PROMPTPAY', 'SCB', 'SHOPEE', 'TRUEMONEY'],
  PHP: ['7ELEVEN', 'BPI', 'CEBUANA', 'GCASH', 'GRABPAY', 'PAYMAYA', 'SHOPEE', 'CREDIT', 'UBP'],
  BRL: ['AME', 'BANK TRANSFER', 'BOLETO', 'MERCADO PAGO', 'PAYPAL', 'PICPAY', 'PIX'],
  MXN: ['BANK TRANSFER', 'OXXO', 'PAYCASH'],
  VND: ['WOORI', 'MOMO', 'VIETTELPAY', 'VNPTPAY', 'SHOPEE', 'APPOTA', 'ZALOPAY'],
  MYR: ['TNG', 'MCASH', 'BOOST', 'GRABPAY', 'FPX', 'UNIONPAY'],
}

export default {
  data() {
    return {
      brandName: env.brandName,
      logo: env.logo,
      logoError: false,
      email: env.email,
      phone: env.phone,
      address: env.address,
      copyRight: env.copyRight,
      currency: this.$store.state.orderInfo.gameCurrency,
    }
  },
  computed: {
    showLogo() {
      return !!this.logo && !this.logoError
    },
    markLetter() {
      return (this.brandName || 'L').trim().charAt(0).toUpperCase()
    },
    channelList() {
      return CHANNELS[this.currency || 'IDR'] || CHANNELS.IDR
    },
    region() {
      return this.currency || 'IDR'
    },
  },
  methods: {
    jump(path) {
      this.$router.push({ path: `/${path}` })
    },
  },
}
</script>

<style lang="scss" scoped>
.brand {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 15px;

  .nm {
    font-size: 11px;
    letter-spacing: 0.34em;
    text-transform: uppercase;
    font-weight: 700;
  }
}
</style>
